module.exports = __webpack_public_path__ + "img/Villa_Borna_49.8e98f9ec.jpg";